import React from 'react'
import { useChartHeight, useChartWidth } from 'recharts'

// Center total label — sized to fit inside the donut hole. Pie has no
// built-in center-label API (unlike Bar/Area, it never calls
// Label.renderCallByParent), so this reads the same pixel dimensions Pie's
// own radius math (PolarUtils.getMaxRadius) derives from via
// useChartWidth/useChartHeight, then shrinks the text to fit the hole.
// Capped at the original hard-coded 32px so a full-size charts-v2 panel donut
// (~400px, innerRadius ~90-100px) renders unchanged — only a small donut like
// the feedback summary card's shrinks the text.
const CENTER_LABEL_MAX_FONT_PX = 32
const CENTER_LABEL_MIN_FONT_PX = 10

export function CenterTotalLabel({
  total,
}: {
  total: string
}): React.ReactElement {
  const width = useChartWidth() ?? 0
  const height = useChartHeight() ?? 0
  const maxRadius = Math.min(width, height) / 2
  const innerRadiusPx = maxRadius * 0.5 // matches Pie's innerRadius="50%"
  const fitted = (innerRadiusPx * 2 * 0.88) / (total.length * 0.6)
  const fontSize = Math.max(
    CENTER_LABEL_MIN_FONT_PX,
    Math.min(CENTER_LABEL_MAX_FONT_PX, fitted),
  )
  return (
    <text
      x="50%"
      y="50%"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize={fontSize}
      fontWeight="bold"
      fill="#333"
    >
      {total}
    </text>
  )
}
